module.exports = __webpack_public_path__ + "img/total-package-warn_cw.a16b2f86.jpg";